/**
 * 2FA available services enum.
 */
const TWO_FACTOR_SERVICES_ENUM = {
  EMAIL: 'email',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
}

/**
 * 2FA login steps enum.
 */
const TWO_FACTOR_LOGIN_STEPS_ENUM = {
  FIRST: 'VerificationCode',
  SECOND: 'VerificationCodeOptions',
  THIRD: 'ReservationCode'
}

export {
  TWO_FACTOR_SERVICES_ENUM,
  TWO_FACTOR_LOGIN_STEPS_ENUM
}
